/**
 * Central country registry (Feb 2026).
 *
 * The user rollout starts small; we'll add more entries over time.
 * List is intentionally short and stored alphabetically so any UI that
 * renders the list doesn't need to re-sort it. Keep it that way.
 */
export const COUNTRIES = [
  'Australia',
  'England',
  'France',
  'Ireland',
  'Italy',
  'New Zealand',
  'Scotland',
  'United States of America',
  'Wales',
];

/** Default country used when nothing else is known (backfill + hard fallback). */
export const DEFAULT_COUNTRY = 'New Zealand';
